
















import VueOptions from '@utils/VueOptions'
import Back from '@modules/ui/buttons/Back'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import SupplierOrgSelector from '@superUI/Selectors/SupplierOrgSelector'
import EventSetForm from '@superUI/Forms/EventSetForm'
import RequestButton from '@components/RequestButton'

settings =
  name: 'EventSetCreate'
  components: { Back, SuperContainerView, SupplierOrgSelector, EventSetForm, RequestButton }
  resources:
    newEventSet:
        resourceName: 'event_set'
        slug: 'event_sets/new'
  vue:
    data: ->
      selectedSubSupplierId: null
      selectedTopSupplierId: null
      selectedSupplierId: null

    methods:
      onSave: (item) -> @$router.push({ name: 'EventSetShowPage', params: { eventSetId: item.id } })

      hiSave: ->
        @prime.newEventSet.supplier_id = @selectedSupplierId
        @saveItem('prime.newEventSet')

      hiBack: ->
        if @selectedSupplierId
          @selectedSubSupplierId = null
          @selectedSupplierId = null
        else
          @selectedSubSupplierId = null
          @selectedTopSupplierId = null

      hiSupplierSelected: (selectedSupplier) ->
        @selectedSupplierId = selectedSupplier.id

export default VueOptions.vue settings
